var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWatch = function SvgWatch(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M30.5071 15.4932C33.0165 19.801 32.3087 25.2587 28.7835 28.784C25.2582 32.3092 19.8005 33.017 15.4927 30.5076C17.8035 34.5079 22.3693 36.636 26.9189 35.8335C31.4684 35.0309 35.0304 31.4689 35.833 26.9193C36.6356 22.3698 34.5074 17.804 30.5071 15.4932Z",
    fill: "#FC628F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M20 37V41.2494C23.2583 42.2495 26.7417 42.2495 30 41.2494V37C26.7999 38.3327 23.2001 38.3327 20 37H20Z",
    fill: "#FC628F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M25 8C23.3052 7.99931 21.6199 8.25217 20 8.7502V13C23.2001 11.6673 26.7999 11.6673 30 13V8.7502C28.3801 8.25217 26.6948 7.99931 25 8Z",
    fill: "#FC628F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 14.0572C35.7373 16.441 37.9997 20.5672 38 25C37.9997 29.4328 35.7373 33.559 32 35.9428V47C32 48.6569 30.6568 50 29 50H20.9999C20.2043 50 19.4412 49.6839 18.8786 49.1213C18.316 48.5587 17.9999 47.7957 17.9999 47V35.9428C14.2625 33.5592 12 29.4329 12 25C12 20.5671 14.2625 16.4408 17.9999 14.0572V3C17.9999 1.34315 19.3431 0 20.9999 0H29C30.6568 0 32 1.34315 32 3V14.0572ZM21 2C20.4477 2 20 2.44772 20 3V13C23.2001 11.6673 26.7998 11.6673 30 13V3C30 2.44772 29.5523 2 29 2H21ZM30 47C30 47.5523 29.5523 48 29 48H21C20.4477 48 20 47.5523 20 47V37C23.2001 38.3327 26.7998 38.3327 30 37V47ZM14 25C14 31.0751 18.9248 36 25 36C31.0723 35.9932 35.9931 31.0723 36 25C36 18.9249 31.0751 14 25 14C18.9248 14 14 18.9249 14 25Z",
    fill: "#FC628F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24.5856V19C26 18.4477 25.5523 18 25 18C24.4477 18 24 18.4477 24 19V25V25.0034C24.0009 25.2625 24.1031 25.5109 24.2846 25.6958L24.2922 25.707L28.5348 29.9496C28.7863 30.2076 29.1571 30.3103 29.5055 30.2186C29.8539 30.1268 30.126 29.8548 30.2179 29.5064C30.3097 29.158 30.2069 28.7871 29.949 28.5356L26 24.5856Z",
    fill: "#FC628F"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWatch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/watch.ea1982876975cebc3cf3d29551503b8d.svg";